<template>
  <v-dialog
      v-model="dialog"
      persistent
  >

    <v-card>
      <v-card-actions>
        <v-btn
            class="mx-2 button-position"
            fab
            dark
            small
            color="primary"
            @click="closeModal"
        >
          <v-icon dark>
            mdi-minus
          </v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text style="height: 900px">
        <sales-list
            :salesListClickAutoSettingData="salesListClickAutoSettingData"
        />
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
/**
 * 배치에서 배출 확인 버튼을 클릭했을때 나오는 모달입니다.
 */
import SalesList from "@/views/sales/SalesList";
export default {
  name: "SalesModal",
  props:{
    dialog:{
      type:Boolean,
    },
    salesListClickAutoSettingData:{
      type:Object
    }

  },
  components:{
    SalesList
  },
  methods:{
    closeModal() {
      this.$emit('close-modal')
    }
  }
}
</script>

<style scoped>
.button-position{
  position: absolute;
  top: 60px;
  right: 50px;
  z-index: 50;
}

>>>.v-dialog {
    overflow-y: visible;

}
>>>.v-dialog:not(.v-dialog--fullscreen) {
    max-height: none;

}
>>>.v-dialog .v-card .v-card__text{
    overflow-y: hidden;

}

</style>